import Backbone from 'backbone';
import $ from 'jquery';

import Auth from './model/auth';
import Config from './config';
import Form from './view/form';
import CodeForm from './view/module/auth/code.form';
import LoginForm from './view/module/auth/login.form';

import { ask, } from './utils/popups';
import { get, pst } from './http/api';
import { requestify } from './utils/promisify';

const fn = authCallback => Promise.resolve()
    .then( () => {
        // No token?  
        if (!Config.token())
            throw new Error();
    } )
    .then( () => {
        const cbUser = requestify( $.getJSON( Config.url( '/users/current') ) );
        const msUser = requestify( $.getJSON( `/users/current?token=${Config.token()}` ) );

        return Promise.all( [cbUser, msUser] )
            .then( ([cbResp, msResp]) => {
                // Token expired?
                if (+cbResp.res === 0)
                    throw new Error();
                if (!msResp.user)
                    throw new Error();

                return cbResp;
            } );
    } )
    // otherwise run authorization
    .catch( () => authCallback() )
    // remember auth data
    .then( subject => {
        const { id, token, fio, role_id, clusters, department_id, map_extent, organization_ids, role: { code, privileges, level } } = subject;
        const [cluster] = clusters;

        Config.token( token );
        Config.user( fio );
        Config.userId( id );
        Config.cluster( cluster ? cluster : null );
        Config.clusters( clusters );
        Config.role( role_id );
        Config.roleCode( code );
        Config.level( level );
        Config.privileges( privileges );
        Config.organization( department_id );
        Config.orgs( organization_ids.map( id => +id ) );
        Config.mapExtent( map_extent.map( number => +number ) );
        
        $( document.body ).on( 'click', '.logout-link', logout );

        delete subject.token;
        delete subject.res;
        delete subject.resText;

        return { subject, token: Config.token() };
    } );

export default fn( authByLogin );

function await2fa({ token, next_attempt_at, email }) {
    return CodeForm.popup( { 
        
        next_attempt_at, email,

        send: (code, form) => pst( `/auth/2fa/confirm/${token}?apiVersion=2.0` ).cerebellum()
            .body( { code } )
            .execute()
            .catch( resp => Form.handleHttpError( form, resp ) ),

        newCode: form => pst( `/auth/2fa/new-code/${token}?apiVersion=2.0` ).cerebellum()
            .execute()
            .then( ({ next_attempt_at }) => form.options.next_attempt_at = next_attempt_at )

    } );
}

function auth({ login, password }) {
    const cbAuth = requestify( new Auth( { login, password, } ).save() )
        .then( resp => {
            if ([false, 'f', undefined].includes( resp.need2fa ))
                return resp;
            
            // token, next_attempt_at, email
            return await2fa( resp ) 
                .then( r => r, () => authByLogin() );
        } );

    const msAuth = pst( '/auth' ).mapsurfer()
        .body( { login, password } )
        .execute();

    return Promise.all( [cbAuth, msAuth] )
        // cb or ms fail -> 
        //   cb ok -> look at ms
        //   cb fail -> fail, take cb message
        .then( ([cbResp/*, msResp*/]) => cbResp, () => cbAuth.then( () => msAuth ) );
}

function authByLogin() {
    return get( `/version` ).cerebellum()
        .execute()
        .then( resp => [true, 't'].includes( resp.password_restore ) )
        .then( password_restore => {
            const binding = new LoginForm()
                .bind( new Auth().set( 'password_restore' , password_restore ) );

            return ask( binding,
                'auth::modal - title', 'actions::sign in', '', 
                form => {
                    const { login, secretString } = form.model.toJSON();
                    return auth( { login, password: secretString, } );
                } );
        } );
}

function logout() {
    Config.token( '' );
    Config.user( '' );
    Config.userId( '' );
    Config.role( '' );
    Config.roleCode( '' );
    Config.privileges( {} );
    Config.organization( '' );
    
    // Logout from MapSurfer
    $.get( '/logout' ).always( () => location.assign( '/' ) );
}


// WEBPACK FOOTER //
// ./src/js/auth.js